export type BudgetedRuntimeLoopOptions = {
  intervalMs: number
  idleTimeoutMs?: number
  maxTaskMs?: number
  label?: string
}

export function createBudgetedRuntimeLoop(task: () => void, options: BudgetedRuntimeLoopOptions) {
  let timer: ReturnType<typeof setInterval> | null = null
  const tick = () => {
    const start = typeof performance !== 'undefined' ? performance.now() : Date.now()
    try { task() }
    catch (error) { console.error('[INYRON budgeted runtime loop]', options.label ?? 'runtime', error) }
    const elapsed = (typeof performance !== 'undefined' ? performance.now() : Date.now()) - start
    if (options.maxTaskMs && elapsed > options.maxTaskMs)
      console.warn('[INYRON budgeted runtime loop slow]', options.label ?? 'runtime', elapsed)
  }
  return {
    start() {
      if (timer !== null) return
      const interval = Number.isFinite(options.intervalMs) ? Math.max(16, options.intervalMs) : 16
      timer = globalThis.setInterval(tick, interval)
    },
    stop() {
      if (timer === null) return
      globalThis.clearInterval(timer)
      timer = null
    },
  }
}
